"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryJSON = void 0;
exports.CountryJSON = {
    AC: {
        code: "AC",
        name: "Ascension",
        cname: "阿森松",
        twName: "阿森松",
        codeAlpha3: "AC",
        //image: "",
        phoneAreaCode: "247",
        mcc: "",
    },
    AND: {
        code: "AD",
        name: "Andorra",
        cname: "安道尔",
        twName: "安道爾",
        codeAlpha3: "AND",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/andorra.png"),
        phoneAreaCode: "376",
        mcc: "213",
    },
    ARE: {
        code: "AE",
        name: "United Arab Emirates",
        cname: "阿联酋",
        twName: "阿聯酋",
        codeAlpha3: "ARE",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/united_arab_emirates_uae.png"),
        phoneAreaCode: "971",
        mcc: "424|430|431",
    },
    AFG: {
        code: "AF",
        name: "Afghanistan",
        cname: "阿富汗",
        twName: "阿富汗",
        codeAlpha3: "AFG",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/afghanistan.png"),
        phoneAreaCode: "93",
        mcc: "412",
    },
    ATG: {
        code: "AG",
        name: "Antigua and Barbuda",
        cname: "安提瓜和巴布达",
        twName: "安提瓜和巴布達",
        codeAlpha3: "ATG",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/antigua_and_barbuda.png"),
        phoneAreaCode: "1268",
        mcc: "344",
    },
    AIA: {
        code: "AI",
        name: "Anguilla",
        cname: "安圭拉",
        twName: "安圭拉",
        codeAlpha3: "AIA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/anguilla.png"),
        phoneAreaCode: "1264",
        mcc: "365",
    },
    ALB: {
        code: "AL",
        name: "Albania",
        cname: "阿尔巴尼亚",
        twName: "阿爾巴尼亞",
        codeAlpha3: "ALB",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/albania.png"),
        phoneAreaCode: "355",
        mcc: "276"
    },
    ARM: {
        code: "AM",
        name: "Armenia",
        cname: "亚美尼亚",
        twName: "亞美尼亞",
        codeAlpha3: "ARM",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/armenia.png"),
        phoneAreaCode: "374",
        mcc: "283"
    },
    AGO: {
        code: "AO",
        name: "Angola",
        cname: "安哥拉",
        twName: "安哥拉",
        codeAlpha3: "AGO",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/angola.png"),
        phoneAreaCode: "244",
        mcc: "631"
    },
    ARG: {
        code: "AR",
        name: "Argentina",
        cname: "阿根廷",
        twName: "阿根廷",
        codeAlpha3: "ARG",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/argentina.png"),
        phoneAreaCode: "54",
        mcc: "722"
    },
    ASM: {
        code: "AS",
        name: "American Samoa",
        cname: "美属萨摩亚",
        twName: "美屬薩摩亞",
        codeAlpha3: "ASM",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/american_samoa.png"),
        phoneAreaCode: "",
        mcc: "544"
    },
    AUT: {
        code: "AT",
        name: "Austria",
        cname: "奥地利",
        twName: "奧地利",
        codeAlpha3: "AUT",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/austria.png"),
        phoneAreaCode: "43",
        mcc: "232"
    },
    AUS: {
        code: "AU",
        name: "Australia",
        cname: "澳大利亚",
        twName: "澳大利亞",
        codeAlpha3: "AUS",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/australia.png"),
        phoneAreaCode: "61",
        mcc: "505"
    },
    ABW: {
        code: "AW",
        name: "Aruba",
        cname: "阿鲁巴",
        twName: "阿魯巴",
        codeAlpha3: "ABW",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/aruba.png"),
        phoneAreaCode: "297",
        mcc: "363"
    },
    AZE: {
        code: "AZ",
        name: "Azerbaijan",
        cname: "阿塞拜疆",
        twName: "阿塞拜疆",
        codeAlpha3: "AZE",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/azerbaijan.png"),
        phoneAreaCode: "994",
        mcc: "400"
    },
    BIH: {
        code: "BA",
        name: "Bosnia and Herzegovina",
        cname: "波黑",
        twName: "波黑",
        codeAlpha3: "BIH",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/bosnia_and_herzegovina.png"),
        phoneAreaCode: "387",
        mcc: "218"
    },
    BRB: {
        code: "BB",
        name: "Barbados",
        cname: "巴巴多斯",
        twName: "巴巴多斯",
        codeAlpha3: "BRB",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/barbados.png"),
        phoneAreaCode: "1246",
        mcc: "342"
    },
    BGD: {
        code: "BD",
        name: "Bangladesh",
        cname: "孟加拉国",
        twName: "孟加拉國",
        codeAlpha3: "BGD",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/bangladesh.png"),
        phoneAreaCode: "880",
        mcc: "470"
    },
    BEL: {
        code: "BE",
        name: "Belgium",
        cname: "比利时",
        twName: "比利時",
        codeAlpha3: "BEL",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/belgium.png"),
        phoneAreaCode: "32",
        mcc: "206"
    },
    BFA: {
        code: "BF",
        name: "Burkina Faso",
        cname: "布基纳法索",
        twName: "布基納法索",
        codeAlpha3: "BFA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/burkina_faso.png"),
        phoneAreaCode: "226",
        mcc: "613"
    },
    BGR: {
        code: "BG",
        name: "Bulgaria",
        cname: "保加利亚",
        twName: "保加利亞",
        codeAlpha3: "BGR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/bulgaria.png"),
        phoneAreaCode: "359",
        mcc: "284"
    },
    BHR: {
        code: "BH",
        name: "Bahrain",
        cname: "巴林",
        twName: "巴林",
        codeAlpha3: "BHR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/bahrain.png"),
        phoneAreaCode: "973",
        mcc: "426"
    },
    BDI: {
        code: "BI",
        name: "Burundi",
        cname: "布隆迪",
        twName: "布隆迪",
        codeAlpha3: "BDI",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/burundi.png"),
        phoneAreaCode: "257",
        mcc: "642"
    },
    BEN: {
        code: "BJ",
        name: "Benin",
        cname: "贝宁",
        twName: "貝寧",
        codeAlpha3: "BEN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/benin.png"),
        phoneAreaCode: "229",
        mcc: "616"
    },
    BMU: {
        code: "BM",
        name: "Bermuda",
        cname: "百慕大",
        twName: "百慕大",
        codeAlpha3: "BMU",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/bermuda.png"),
        phoneAreaCode: "1441",
        mcc: "350"
    },
    BRN: {
        code: "BN",
        name: "Brunei Darussalam",
        cname: "文莱",
        twName: "文萊",
        codeAlpha3: "BRN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/brunei_darussalam.png"),
        phoneAreaCode: "673",
        mcc: "528"
    },
    BOL: {
        code: "BO",
        name: "Bolivia",
        cname: "玻利维亚",
        twName: "玻利維亞",
        codeAlpha3: "BOL",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/bolivia.png"),
        phoneAreaCode: "591",
        mcc: "736"
    },
    BES: {
        code: "BQ",
        name: "Bonaire, Sint Eustatius and Saba",
        cname: "荷兰加勒比区",
        twName: "荷蘭加勒比區",
        codeAlpha3: "BES",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/bonaire_sint_eustatius_and_saba.png"),
        phoneAreaCode: "5997",
        mcc: ""
    },
    BRA: {
        code: "BR",
        name: "Brazil",
        cname: "巴西",
        twName: "巴西",
        codeAlpha3: "BRA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/brazil.png"),
        phoneAreaCode: "55",
        mcc: "724"
    },
    BHS: {
        code: "BS",
        name: "Bahamas",
        cname: "巴哈马",
        twName: "巴哈馬",
        codeAlpha3: "BHS",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/bahamas.png"),
        phoneAreaCode: "1242",
        mcc: "364"
    },
    BTN: {
        code: "BT",
        name: "Bhutan",
        cname: "不丹",
        twName: "不丹",
        codeAlpha3: "BTN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/bhutan.png"),
        phoneAreaCode: "975",
        mcc: "402"
    },
    BWA: {
        code: "BW",
        name: "Botswana",
        cname: "博茨瓦纳",
        twName: "博茨瓦納",
        codeAlpha3: "BWA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/botswana.png"),
        phoneAreaCode: "267",
        mcc: "652"
    },
    BLR: {
        code: "BY",
        name: "Belarus",
        cname: "白俄罗斯",
        twName: "白俄羅斯",
        codeAlpha3: "BLR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/belarus.png"),
        phoneAreaCode: "375",
        mcc: "257"
    },
    BLZ: {
        code: "BZ",
        name: "Belize",
        cname: "伯利兹",
        twName: "伯利茲",
        codeAlpha3: "BLZ",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/belize.png"),
        phoneAreaCode: "501",
        mcc: "702"
    },
    CAN: {
        code: "CA",
        name: "Canada",
        cname: "加拿大",
        twName: "加拿大",
        codeAlpha3: "CAN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/canada.png"),
        phoneAreaCode: "1",
        mcc: "302"
    },
    COD: {
        code: "CD",
        name: "Congo, the Democratic Republic of the",
        cname: "刚果（金）",
        twName: "剛果（金）",
        codeAlpha3: "COD",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/congo_the_democratic_republic_of_the.png"),
        phoneAreaCode: "243",
        mcc: "630"
    },
    CAF: {
        code: "CF",
        name: "Central African Republic",
        cname: "中非",
        twName: "中非",
        codeAlpha3: "CAF",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/central_african_republic.png"),
        phoneAreaCode: "236",
        mcc: "623"
    },
    COG: {
        code: "CG",
        name: "Congo",
        cname: "刚果（布）",
        twName: "剛果（布）",
        codeAlpha3: "COG",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/congo_the_democratic_republic_of_the.png"),
        phoneAreaCode: "242",
        mcc: "629"
    },
    CHE: {
        code: "CH",
        name: "Switzerland",
        cname: "瑞士",
        twName: "瑞士",
        codeAlpha3: "CHE",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/switzerland.png"),
        phoneAreaCode: "41",
        mcc: "228"
    },
    CIV: {
        code: "CI",
        name: "Cote D'Ivoire",
        cname: "科特迪瓦",
        twName: "科特迪瓦",
        codeAlpha3: "CIV",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/cote_d'ivoire.png"),
        phoneAreaCode: "225",
        mcc: "612"
    },
    COK: {
        code: "CK",
        name: "Cook Islands",
        cname: "库克群岛",
        twName: "庫克群島",
        codeAlpha3: "COK",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/the_cook_islands.png"),
        phoneAreaCode: "682",
        mcc: "548"
    },
    CHL: {
        code: "CL",
        name: "Chile",
        cname: "智利",
        twName: "智利",
        codeAlpha3: "CHL",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/chile.png"),
        phoneAreaCode: "56",
        mcc: "730"
    },
    CMR: {
        code: "CM",
        name: "Cameroon",
        cname: "喀麦隆",
        twName: "喀麥隆",
        codeAlpha3: "CMR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/cameroon.png"),
        phoneAreaCode: "237",
        mcc: "624"
    },
    CHN: {
        code: "CN",
        name: "China",
        cname: "中国",
        twName: "中國",
        codeAlpha3: "CHN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/china.png"),
        phoneAreaCode: "86",
        mcc: "460|461"
    },
    COL: {
        code: "CO",
        name: "Colombia",
        cname: "哥伦比亚",
        twName: "哥倫比亞",
        codeAlpha3: "COL",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/colombia.png"),
        phoneAreaCode: "57",
        mcc: "732"
    },
    CRI: {
        code: "CR",
        name: "Costa Rica",
        cname: "哥斯达黎加",
        twName: "哥斯達黎加",
        codeAlpha3: "CRI",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/costa_rica.png"),
        phoneAreaCode: "506",
        mcc: "712"
    },
    CUB: {
        code: "CU",
        name: "Cuba",
        cname: "古巴",
        twName: "古巴",
        codeAlpha3: "CUB",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/cuba.png"),
        phoneAreaCode: "53",
        mcc: "368"
    },
    CPV: {
        code: "CV",
        name: "Cape Verde",
        cname: "佛得角",
        twName: "佛得角",
        codeAlpha3: "CPV",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/cape_verde.png"),
        phoneAreaCode: "238",
        mcc: "625"
    },
    CUW: {
        code: "CW",
        name: "Curaçao",
        cname: "库拉索",
        twName: "庫拉索",
        codeAlpha3: "CUW",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/curaçao.png"),
        phoneAreaCode: "5999",
        mcc: "362"
    },
    CYP: {
        code: "CY",
        name: "Cyprus",
        cname: "塞浦路斯",
        twName: "塞浦路斯",
        codeAlpha3: "CYP",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/northern_cyprus.png"),
        phoneAreaCode: "357",
        mcc: "280"
    },
    CZE: {
        code: "CZ",
        name: "Czech Republic",
        cname: "捷克",
        twName: "捷克",
        codeAlpha3: "CZE",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/czech_republic.png"),
        phoneAreaCode: "420",
        mcc: "230"
    },
    DEU: {
        code: "DE",
        name: "Germany",
        cname: "德国",
        twName: "德國",
        codeAlpha3: "DEU",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/germany.png"),
        phoneAreaCode: "49",
        mcc: "262"
    },
    DG: {
        code: "DG",
        name: "Diego Garcia",
        cname: "",
        twName: "",
        codeAlpha3: "DG",
        //image: "",
        phoneAreaCode: "",
        mcc: ""
    },
    DJI: {
        code: "DJ",
        name: "Djibouti",
        cname: "吉布提",
        twName: "吉布提",
        codeAlpha3: "DJI",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/djibouti.png"),
        phoneAreaCode: "253",
        mcc: "638"
    },
    DNK: {
        code: "DK",
        name: "Denmark",
        cname: "丹麦",
        twName: "丹麥",
        codeAlpha3: "DNK",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/denmark.png"),
        phoneAreaCode: "45",
        mcc: "238"
    },
    DMA: {
        code: "DM",
        name: "Dominica",
        cname: "多米尼克",
        twName: "多米尼克",
        codeAlpha3: "DMA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/dominican_republic.png"),
        phoneAreaCode: "1767",
        mcc: "366"
    },
    DOM: {
        code: "DO",
        name: "Dominican Republic",
        cname: "多米尼加",
        twName: "多米尼加",
        codeAlpha3: "DOM",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/dominican_republic.png"),
        phoneAreaCode: "1809,1829,1849",
        mcc: "370"
    },
    DZA: {
        code: "DZ",
        name: "Algeria",
        cname: "阿尔及利亚",
        twName: "阿爾及利亞",
        codeAlpha3: "DZA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/algeria.png"),
        phoneAreaCode: "213",
        mcc: "603"
    },
    ECU: {
        code: "EC",
        name: "Ecuador",
        cname: "厄瓜多尔",
        twName: "厄瓜多爾",
        codeAlpha3: "ECU",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/ecuador.png"),
        phoneAreaCode: "593",
        mcc: "740"
    },
    EST: {
        code: "EE",
        name: "Estonia",
        cname: "爱沙尼亚",
        twName: "愛沙尼亞",
        codeAlpha3: "EST",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/estonia.png"),
        phoneAreaCode: "372",
        mcc: "248"
    },
    EGY: {
        code: "EG",
        name: "Egypt",
        cname: "埃及",
        twName: "埃及",
        codeAlpha3: "EGY",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/egypt.png"),
        phoneAreaCode: "20",
        mcc: "602"
    },
    ERI: {
        code: "ER",
        name: "Eritrea",
        cname: "厄立特里亚",
        twName: "厄立特裏亞",
        codeAlpha3: "ERI",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/eritrea.png"),
        phoneAreaCode: "291",
        mcc: "657"
    },
    ESP: {
        code: "ES",
        name: "Spain",
        cname: "西班牙",
        twName: "西班牙",
        codeAlpha3: "ESP",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/spain.png"),
        phoneAreaCode: "34",
        mcc: "214"
    },
    ETH: {
        code: "ET",
        name: "Ethiopia",
        cname: "埃塞俄比亚",
        twName: "埃塞俄比亞",
        codeAlpha3: "ETH",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/ethiopia.png"),
        phoneAreaCode: "251",
        mcc: "636"
    },
    FIN: {
        code: "FI",
        name: "Finland",
        cname: "芬兰",
        twName: "芬蘭",
        codeAlpha3: "FIN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/finland.png"),
        phoneAreaCode: "358",
        mcc: "244"
    },
    FJI: {
        code: "FJ",
        name: "Fiji",
        cname: "斐济",
        twName: "斐濟",
        codeAlpha3: "FJI",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/fiji.png"),
        phoneAreaCode: "679",
        mcc: "542"
    },
    FLK: {
        code: "FK",
        name: "Falkland Islands (Malvinas)",
        cname: "福克兰群岛",
        twName: "福克蘭群島",
        codeAlpha3: "FLK",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/falkland_islands_(malvinas).png"),
        phoneAreaCode: "500",
        mcc: "750"
    },
    FSM: {
        code: "FM",
        name: "Micronesia, Federated States of",
        cname: "密克罗尼西亚联邦",
        twName: "密克羅尼西亞聯邦",
        codeAlpha3: "FSM",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/micronesia_federated_states_of.png"),
        phoneAreaCode: "691",
        mcc: "550"
    },
    FRO: {
        code: "FO",
        name: "Faroe Islands",
        cname: "法罗群岛",
        twName: "法羅群島",
        codeAlpha3: "FRO",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/the_faroe_islands.png"),
        phoneAreaCode: "298",
        mcc: "288"
    },
    FRA: {
        code: "FR",
        name: "France",
        cname: "法国",
        twName: "法國",
        codeAlpha3: "FRA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/france.png"),
        phoneAreaCode: "33",
        mcc: "208"
    },
    GAB: {
        code: "GA",
        name: "Gabon",
        cname: "加蓬",
        twName: "加蓬",
        codeAlpha3: "GAB",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/gabon.png"),
        phoneAreaCode: "241",
        mcc: "628"
    },
    GBR: {
        code: "GB",
        name: "UK",
        cname: "英国",
        twName: "英國",
        codeAlpha3: "GBR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/ukraine.png"),
        phoneAreaCode: "44",
        mcc: "234|235"
    },
    GRD: {
        code: "GD",
        name: "Grenada",
        cname: "格林纳达",
        twName: "格林納達",
        codeAlpha3: "GRD",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/grenada.png"),
        phoneAreaCode: "1473",
        mcc: "352"
    },
    GEO: {
        code: "GE",
        name: "Georgia",
        cname: "格鲁吉亚",
        twName: "格魯吉亞",
        codeAlpha3: "GEO",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/south_georgia_and_the_south_sandwich_islands.png"),
        phoneAreaCode: "995",
        mcc: "282"
    },
    GUF: {
        code: "GF",
        name: "French Guiana",
        cname: "法属圭亚那",
        twName: "法屬圭亞那",
        codeAlpha3: "GUF",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/french_guiana.png"),
        phoneAreaCode: "594",
        mcc: "742"
    },
    GHA: {
        code: "GH",
        name: "Ghana",
        cname: "加纳",
        twName: "加納",
        codeAlpha3: "GHA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/ghana.png"),
        phoneAreaCode: "233",
        mcc: "620"
    },
    GIB: {
        code: "GI",
        name: "Gibraltar",
        cname: "直布罗陀",
        twName: "直布羅陀",
        codeAlpha3: "GIB",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/gibraltar.png"),
        phoneAreaCode: "350",
        mcc: "266"
    },
    GRL: {
        code: "GL",
        name: "Greenland",
        cname: "格陵兰",
        twName: "格陵蘭",
        codeAlpha3: "GRL",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/greenland.png"),
        phoneAreaCode: "299",
        mcc: "290"
    },
    GMB: {
        code: "GM",
        name: "Gambia",
        cname: "冈比亚",
        twName: "岡比亞",
        codeAlpha3: "GMB",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/gambia.png"),
        phoneAreaCode: "220",
        mcc: "607"
    },
    GIN: {
        code: "GN",
        name: "Guinea",
        cname: "几内亚",
        twName: "幾內亞",
        codeAlpha3: "GIN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/papua_new_guinea.png"),
        phoneAreaCode: "224",
        mcc: "611"
    },
    GLP: {
        code: "GP",
        name: "Guadeloupe",
        cname: "瓜德罗普",
        twName: "瓜德羅普",
        codeAlpha3: "GLP",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/guadeloupe.png"),
        phoneAreaCode: "590",
        mcc: "340"
    },
    GNQ: {
        code: "GQ",
        name: "Equatorial Guinea",
        cname: "赤道几内亚",
        twName: "赤道幾內亞",
        codeAlpha3: "GNQ",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/equatorial_guinea.png"),
        phoneAreaCode: "240",
        mcc: "627"
    },
    GRC: {
        code: "GR",
        name: "Greece",
        cname: "希腊",
        twName: "希臘",
        codeAlpha3: "GRC",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/greece.png"),
        phoneAreaCode: "30",
        mcc: "202"
    },
    GTM: {
        code: "GT",
        name: "Guatemala",
        cname: "危地马拉",
        twName: "危地馬拉",
        codeAlpha3: "GTM",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/guatemala.png"),
        phoneAreaCode: "502",
        mcc: "704"
    },
    GUM: {
        code: "GU",
        name: "Guam",
        cname: "关岛",
        twName: "關島",
        codeAlpha3: "GUM",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/guam.png"),
        phoneAreaCode: "1671",
        mcc: "535"
    },
    GNB: {
        code: "GW",
        name: "Guinea-Bissau",
        cname: "几内亚比绍",
        twName: "幾內亞比紹",
        codeAlpha3: "GNB",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/guinea-bissau.png"),
        phoneAreaCode: "245",
        mcc: "632"
    },
    GUY: {
        code: "GY",
        name: "Guyana",
        cname: "圭亚那",
        twName: "圭亞那",
        codeAlpha3: "GUY",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/guyana.png"),
        phoneAreaCode: "592",
        mcc: "738"
    },
    HKG: {
        code: "HK",
        name: "Hong Kong",
        cname: "中国香港",
        twName: "香港",
        codeAlpha3: "HKG",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/hong_kong.png"),
        phoneAreaCode: "852",
        mcc: "454"
    },
    HND: {
        code: "HN",
        name: "Honduras",
        cname: "洪都拉斯",
        twName: "洪都拉斯",
        codeAlpha3: "HND",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/honduras.png"),
        phoneAreaCode: "504",
        mcc: "708"
    },
    HRV: {
        code: "HR",
        name: "Croatia",
        cname: "克罗地亚",
        twName: "克羅地亞",
        codeAlpha3: "HRV",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/croatia.png"),
        phoneAreaCode: "385",
        mcc: "219"
    },
    HTI: {
        code: "HT",
        name: "Haiti",
        cname: "海地",
        twName: "海地",
        codeAlpha3: "HTI",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/haiti.png"),
        phoneAreaCode: "509",
        mcc: "372"
    },
    HUN: {
        code: "HU",
        name: "Hungary",
        cname: "匈牙利",
        twName: "匈牙利",
        codeAlpha3: "HUN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/hungary.png"),
        phoneAreaCode: "36",
        mcc: "216"
    },
    IDN: {
        code: "ID",
        name: "Indonesia",
        cname: "印尼",
        twName: "印尼",
        codeAlpha3: "IDN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/indonesia.png"),
        phoneAreaCode: "62",
        mcc: "510"
    },
    IRL: {
        code: "IE",
        name: "Ireland",
        cname: "爱尔兰",
        twName: "愛爾蘭",
        codeAlpha3: "IRL",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/northern_ireland.png"),
        phoneAreaCode: "353",
        mcc: "272"
    },
    ISR: {
        code: "IL",
        name: "Israel",
        cname: "以色列",
        twName: "以色列",
        codeAlpha3: "ISR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/israel.png"),
        phoneAreaCode: "972",
        mcc: "425"
    },
    IND: {
        code: "IN",
        name: "India",
        cname: "印度",
        twName: "印度",
        codeAlpha3: "IND",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/india.png"),
        phoneAreaCode: "91",
        mcc: "404|405|406"
    },
    IRQ: {
        code: "IQ",
        name: "Iraq",
        cname: "伊拉克",
        twName: "伊拉克",
        codeAlpha3: "IRQ",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/iraq.png"),
        phoneAreaCode: "964",
        mcc: "418"
    },
    IRN: {
        code: "IR",
        name: "Iran, Islamic Republic of",
        cname: "伊朗",
        twName: "伊朗",
        codeAlpha3: "IRN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/iran_islamic_republic_of.png"),
        phoneAreaCode: "98",
        mcc: "432"
    },
    ISL: {
        code: "IS",
        name: "Iceland",
        cname: "冰岛",
        twName: "冰島",
        codeAlpha3: "ISL",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/iceland.png"),
        phoneAreaCode: "354",
        mcc: "274"
    },
    ITA: {
        code: "IT",
        name: "Italy",
        cname: "意大利",
        twName: "意大利",
        codeAlpha3: "ITA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/italy.png"),
        phoneAreaCode: "39",
        mcc: "222"
    },
    JAM: {
        code: "JM",
        name: "Jamaica",
        cname: "牙买加",
        twName: "牙買加",
        codeAlpha3: "JAM",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/jamaica.png"),
        phoneAreaCode: "1876",
        mcc: "338"
    },
    JOR: {
        code: "JO",
        name: "Jordan",
        cname: "约旦",
        twName: "約旦",
        codeAlpha3: "JOR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/jordan.png"),
        phoneAreaCode: "962",
        mcc: "416"
    },
    JPN: {
        code: "JP",
        name: "Japan",
        cname: "日本",
        twName: "日本",
        codeAlpha3: "JPN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/japan.png"),
        phoneAreaCode: "81",
        mcc: "440|441"
    },
    KEN: {
        code: "KE",
        name: "Kenya",
        cname: "肯尼亚",
        twName: "肯尼亞",
        codeAlpha3: "KEN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/kenya.png"),
        phoneAreaCode: "254",
        mcc: "639"
    },
    KGZ: {
        code: "KG",
        name: "Kyrgyzstan",
        cname: "吉尔吉斯斯坦",
        twName: "吉爾吉斯斯坦",
        codeAlpha3: "KGZ",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/kyrgyzstan.png"),
        phoneAreaCode: "996",
        mcc: "437"
    },
    KHM: {
        code: "KH",
        name: "Cambodia",
        cname: "柬埔寨",
        twName: "柬埔寨",
        codeAlpha3: "KHM",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/cambodia.png"),
        phoneAreaCode: "855",
        mcc: "456"
    },
    KIR: {
        code: "KI",
        name: "Kiribati",
        cname: "基里巴斯",
        twName: "基裏巴斯",
        codeAlpha3: "KIR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/kiribati.png"),
        phoneAreaCode: "686",
        mcc: "545"
    },
    COM: {
        code: "KM",
        name: "Comoros",
        cname: "科摩罗",
        twName: "科摩羅",
        codeAlpha3: "COM",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/comoros.png"),
        phoneAreaCode: "269",
        mcc: "654"
    },
    KNA: {
        code: "KN",
        name: "Saint Kitts and Nevis",
        cname: "圣基茨和尼维斯",
        twName: "聖基茨和尼維斯",
        codeAlpha3: "KNA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/saint_kitts_and_nevis.png"),
        phoneAreaCode: "1869",
        mcc: "356"
    },
    KOR: {
        code: "KR",
        name: "South Korea",
        cname: "韩国",
        twName: "韓國",
        codeAlpha3: "KOR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/south_korea.png"),
        phoneAreaCode: "82",
        mcc: "450"
    },
    KWT: {
        code: "KW",
        name: "Kuwait",
        cname: "科威特",
        twName: "科威特",
        codeAlpha3: "KWT",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/kuwait.png"),
        phoneAreaCode: "965",
        mcc: "419"
    },
    CYM: {
        code: "KY",
        name: "Cayman Islands",
        cname: "开曼群岛",
        twName: "開曼群島",
        codeAlpha3: "CYM",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/cayman_islands.png"),
        phoneAreaCode: "1345",
        mcc: "346"
    },
    KAZ: {
        code: "KZ",
        name: "Kazakhstan",
        cname: "哈萨克斯坦",
        twName: "哈薩克斯坦",
        codeAlpha3: "KAZ",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/kazakhstan.png"),
        phoneAreaCode: "7",
        mcc: "401"
    },
    LAO: {
        code: "LA",
        name: "Lao People's Democratic Republic",
        cname: "老挝",
        twName: "老撾",
        codeAlpha3: "LAO",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/lao_people's_democratic_republic.png"),
        phoneAreaCode: "856",
        mcc: "457"
    },
    LBN: {
        code: "LB",
        name: "Lebanon",
        cname: "黎巴嫩",
        twName: "黎巴嫩",
        codeAlpha3: "LBN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/lebanon.png"),
        phoneAreaCode: "961",
        mcc: "415"
    },
    LCA: {
        code: "LC",
        name: "Saint Lucia",
        cname: "圣卢西亚",
        twName: "聖盧西亞",
        codeAlpha3: "LCA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/saint_lucia.png"),
        phoneAreaCode: "1758",
        mcc: "358"
    },
    LIE: {
        code: "LI",
        name: "Liechtenstein",
        cname: "列支敦士登",
        twName: "列支敦士登",
        codeAlpha3: "LIE",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/liechtenstein.png"),
        phoneAreaCode: "423",
        mcc: "295"
    },
    LKA: {
        code: "LK",
        name: "Sri Lanka",
        cname: "斯里兰卡",
        twName: "斯裏蘭卡",
        codeAlpha3: "LKA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/sri_lanka.png"),
        phoneAreaCode: "94",
        mcc: "413"
    },
    LBR: {
        code: "LR",
        name: "Liberia",
        cname: "利比里亚",
        twName: "利比裏亞",
        codeAlpha3: "LBR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/liberia.png"),
        phoneAreaCode: "231",
        mcc: "618"
    },
    LSO: {
        code: "LS",
        name: "Lesotho",
        cname: "莱索托",
        twName: "萊索托",
        codeAlpha3: "LSO",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/lesotho.png"),
        phoneAreaCode: "266",
        mcc: "651"
    },
    LTU: {
        code: "LT",
        name: "Lithuania",
        cname: "立陶宛",
        twName: "立陶宛",
        codeAlpha3: "LTU",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/lithuania.png"),
        phoneAreaCode: "370",
        mcc: "246"
    },
    LUX: {
        code: "LU",
        name: "Luxembourg",
        cname: "卢森堡",
        twName: "盧森堡",
        codeAlpha3: "LUX",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/luxembourg.png"),
        phoneAreaCode: "352",
        mcc: "270"
    },
    LVA: {
        code: "LV",
        name: "Latvia",
        cname: "拉脱维亚",
        twName: "拉脫維亞",
        codeAlpha3: "LVA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/latvia.png"),
        phoneAreaCode: "371",
        mcc: "247"
    },
    LBY: {
        code: "LY",
        name: "Libya",
        cname: "利比亚",
        twName: "利比亞",
        codeAlpha3: "LBY",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/libya.png"),
        phoneAreaCode: "218",
        mcc: "606"
    },
    MAR: {
        code: "MA",
        name: "Morocco",
        cname: "摩洛哥",
        twName: "摩洛哥",
        codeAlpha3: "MAR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/morocco.png"),
        phoneAreaCode: "212",
        mcc: "604"
    },
    MCO: {
        code: "MC",
        name: "Monaco",
        cname: "摩纳哥",
        twName: "摩納哥",
        codeAlpha3: "MCO",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/monaco.png"),
        phoneAreaCode: "377",
        mcc: "212"
    },
    MDA: {
        code: "MD",
        name: "Moldova, Republic of",
        cname: "摩尔多瓦",
        twName: "摩爾多瓦",
        codeAlpha3: "MDA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/moldova_republic_of.png"),
        phoneAreaCode: "373",
        mcc: "259"
    },
    MNE: {
        code: "ME",
        name: "Montenegro",
        cname: "黑山",
        twName: "黑山",
        codeAlpha3: "MNE",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/montenegro.png"),
        phoneAreaCode: "382",
        mcc: "297"
    },
    MDG: {
        code: "MG",
        name: "Madagascar",
        cname: "马达加斯加",
        twName: "馬達加斯加",
        codeAlpha3: "MDG",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/madagascar.png"),
        phoneAreaCode: "261",
        mcc: "646"
    },
    MHL: {
        code: "MH",
        name: "Marshall Islands",
        cname: "马绍尔群岛",
        twName: "馬紹爾群島",
        codeAlpha3: "MHL",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/marshall_islands.png"),
        phoneAreaCode: "692",
        mcc: "551"
    },
    MKD: {
        code: "MK",
        name: "North Macedonia, Republic of",
        cname: "北马其顿",
        twName: "北馬其頓",
        codeAlpha3: "MKD",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/north_macedonia_republic_of.png"),
        phoneAreaCode: "389",
        mcc: ""
    },
    MLI: {
        code: "ML",
        name: "Mali",
        cname: "马里",
        twName: "馬裏",
        codeAlpha3: "MLI",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/somalia.png"),
        phoneAreaCode: "223",
        mcc: "610"
    },
    MMR: {
        code: "MM",
        name: "Myanmar",
        cname: "缅甸",
        twName: "緬甸",
        codeAlpha3: "MMR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/myanmar_burma.png"),
        phoneAreaCode: "95",
        mcc: "414"
    },
    MNG: {
        code: "MN",
        name: "Mongolia",
        cname: "蒙古",
        twName: "蒙古",
        codeAlpha3: "MNG",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/mongolia.png"),
        phoneAreaCode: "976",
        mcc: "428"
    },
    MAC: {
        code: "MO",
        name: "Macao",
        cname: "中国澳门",
        twName: "澳門",
        codeAlpha3: "MAC",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/macao.png"),
        phoneAreaCode: "853",
        mcc: "455"
    },
    MNP: {
        code: "MP",
        name: "Northern Mariana Islands",
        cname: "北马里亚纳群岛",
        twName: "北馬裏亞納群島",
        codeAlpha3: "MNP",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/northern_mariana_islands.png"),
        phoneAreaCode: "",
        mcc: "534"
    },
    MTQ: {
        code: "MQ",
        name: "Martinique",
        cname: "马提尼克",
        twName: "馬提尼克",
        codeAlpha3: "MTQ",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/martinique.png"),
        phoneAreaCode: "596",
        mcc: "340"
    },
    MRT: {
        code: "MR",
        name: "Mauritania",
        cname: "毛里塔尼亚",
        twName: "毛裏塔尼亞",
        codeAlpha3: "MRT",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/mauritania.png"),
        phoneAreaCode: "222",
        mcc: "609"
    },
    MSR: {
        code: "MS",
        name: "Montserrat",
        cname: "蒙特塞拉特",
        twName: "蒙特塞拉特",
        codeAlpha3: "MSR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/montserrat.png"),
        phoneAreaCode: "1664",
        mcc: "354"
    },
    MLT: {
        code: "MT",
        name: "Malta",
        cname: "马耳他",
        twName: "馬耳他",
        codeAlpha3: "MLT",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/malta.png"),
        phoneAreaCode: "356",
        mcc: "278"
    },
    MUS: {
        code: "MU",
        name: "Mauritius",
        cname: "毛里求斯",
        twName: "毛裏求斯",
        codeAlpha3: "MUS",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/mauritius.png"),
        phoneAreaCode: "230",
        mcc: "617"
    },
    MDV: {
        code: "MV",
        name: "Maldives",
        cname: "马尔代夫",
        twName: "馬爾代夫",
        codeAlpha3: "MDV",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/maldives.png"),
        phoneAreaCode: "960",
        mcc: "472"
    },
    MWI: {
        code: "MW",
        name: "Malawi",
        cname: "马拉维",
        twName: "馬拉維",
        codeAlpha3: "MWI",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/malawi.png"),
        phoneAreaCode: "265",
        mcc: "650"
    },
    MEX: {
        code: "MX",
        name: "Mexico",
        cname: "墨西哥",
        twName: "墨西哥",
        codeAlpha3: "MEX",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/mexico.png"),
        phoneAreaCode: "52",
        mcc: "334"
    },
    MYS: {
        code: "MY",
        name: "Malaysia",
        cname: "马来西亚",
        twName: "馬來西亞",
        codeAlpha3: "MYS",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/malaysia.png"),
        phoneAreaCode: "60",
        mcc: "502"
    },
    MOZ: {
        code: "MZ",
        name: "Mozambique",
        cname: "莫桑比克",
        twName: "莫桑比克",
        codeAlpha3: "MOZ",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/mozambique.png"),
        phoneAreaCode: "258",
        mcc: "643"
    },
    NAM: {
        code: "NA",
        name: "Namibia",
        cname: "纳米比亚",
        twName: "納米比亞",
        codeAlpha3: "NAM",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/namibia.png"),
        phoneAreaCode: "264",
        mcc: "649"
    },
    NCL: {
        code: "NC",
        name: "New Caledonia",
        cname: "新喀里多尼亚",
        twName: "新喀裏多尼亞",
        codeAlpha3: "NCL",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/new_caledonia.png"),
        phoneAreaCode: "687",
        mcc: "546"
    },
    NER: {
        code: "NE",
        name: "Niger",
        cname: "尼日尔",
        twName: "尼日爾",
        codeAlpha3: "NER",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/nigeria.png"),
        phoneAreaCode: "227",
        mcc: "614"
    },
    NFK: {
        code: "NF",
        name: "Norfolk Island",
        cname: "诺福克岛",
        twName: "諾福克島",
        codeAlpha3: "NFK",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/norfolk_island.png"),
        phoneAreaCode: "672",
        mcc: ""
    },
    NGA: {
        code: "NG",
        name: "Nigeria",
        cname: "尼日利亚",
        twName: "尼日利亞",
        codeAlpha3: "NGA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/nigeria.png"),
        phoneAreaCode: "234",
        mcc: "621"
    },
    NIC: {
        code: "NI",
        name: "Nicaragua",
        cname: "尼加拉瓜",
        twName: "尼加拉瓜",
        codeAlpha3: "NIC",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/nicaragua.png"),
        phoneAreaCode: "505",
        mcc: "710"
    },
    NLD: {
        code: "NL",
        name: "Netherlands",
        cname: "荷兰",
        twName: "荷蘭",
        codeAlpha3: "NLD",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/netherlands_antilles.png"),
        phoneAreaCode: "31",
        mcc: "204"
    },
    NOR: {
        code: "NO",
        name: "Norway",
        cname: "挪威",
        twName: "挪威",
        codeAlpha3: "NOR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/norway.png"),
        phoneAreaCode: "47",
        mcc: "242"
    },
    NPL: {
        code: "NP",
        name: "Nepal",
        cname: "尼泊尔",
        twName: "尼泊爾",
        codeAlpha3: "NPL",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/nepal.png"),
        phoneAreaCode: "977",
        mcc: "429"
    },
    NRU: {
        code: "NR",
        name: "Nauru",
        cname: "瑙鲁",
        twName: "瑙魯",
        codeAlpha3: "NRU",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/nauru.png"),
        phoneAreaCode: "674",
        mcc: "536"
    },
    NIU: {
        code: "NU",
        name: "Niue",
        cname: "纽埃",
        twName: "紐埃",
        codeAlpha3: "NIU",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/niue.png"),
        phoneAreaCode: "683",
        mcc: "555"
    },
    NZL: {
        code: "NZ",
        name: "New Zealand",
        cname: "新西兰",
        twName: "新西蘭",
        codeAlpha3: "NZL",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/new_zealand.png"),
        phoneAreaCode: "64",
        mcc: "530"
    },
    OMN: {
        code: "OM",
        name: "Oman",
        cname: "阿曼",
        twName: "阿曼",
        codeAlpha3: "OMN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/romania.png"),
        phoneAreaCode: "968",
        mcc: "422"
    },
    PAN: {
        code: "PA",
        name: "Panama",
        cname: "巴拿马",
        twName: "巴拿馬",
        codeAlpha3: "PAN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/panama.png"),
        phoneAreaCode: "507",
        mcc: "714"
    },
    PER: {
        code: "PE",
        name: "Peru",
        cname: "秘鲁",
        twName: "秘魯",
        codeAlpha3: "PER",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/peru.png"),
        phoneAreaCode: "51",
        mcc: "716"
    },
    PYF: {
        code: "PF",
        name: "French Polynesia",
        cname: "法属波利尼西亚",
        twName: "法屬波利尼西亞",
        codeAlpha3: "PYF",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/french_polynesia.png"),
        phoneAreaCode: "689",
        mcc: "547"
    },
    PNG: {
        code: "PG",
        name: "Papua New Guinea",
        cname: "巴布亚新几内亚",
        twName: "巴布亞新幾內亞",
        codeAlpha3: "PNG",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/papua_new_guinea.png"),
        phoneAreaCode: "675",
        mcc: "537"
    },
    PHL: {
        code: "PH",
        name: "Philippines",
        cname: "菲律宾",
        twName: "菲律賓",
        codeAlpha3: "PHL",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/philippines.png"),
        phoneAreaCode: "63",
        mcc: "515"
    },
    PAK: {
        code: "PK",
        name: "Pakistan",
        cname: "巴基斯坦",
        twName: "巴基斯坦",
        codeAlpha3: "PAK",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/pakistan.png"),
        phoneAreaCode: "92",
        mcc: "410"
    },
    POL: {
        code: "PL",
        name: "Poland",
        cname: "波兰",
        twName: "波蘭",
        codeAlpha3: "POL",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/poland.png"),
        phoneAreaCode: "48",
        mcc: "260"
    },
    SPM: {
        code: "PM",
        name: "Saint Pierre and Miquelon",
        cname: "圣皮埃尔和密克隆",
        twName: "聖皮埃爾和密克隆",
        codeAlpha3: "SPM",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/saint_pierre_and_miquelon.png"),
        phoneAreaCode: "508",
        mcc: "308"
    },
    PRI: {
        code: "PR",
        name: "Puerto Rico",
        cname: "波多黎各",
        twName: "波多黎各",
        codeAlpha3: "PRI",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/puerto_rico.png"),
        phoneAreaCode: "1787",
        mcc: "330"
    },
    PSE: {
        code: "PS",
        name: "Palestinian Territory, Occupied",
        cname: "巴勒斯坦",
        twName: "巴勒斯坦",
        codeAlpha3: "PSE",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/palestinian_territory_occupied.png"),
        phoneAreaCode: "970",
        mcc: "425"
    },
    PRT: {
        code: "PT",
        name: "Portugal",
        cname: "葡萄牙",
        twName: "葡萄牙",
        codeAlpha3: "PRT",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/portugal.png"),
        phoneAreaCode: "351",
        mcc: "268"
    },
    PLW: {
        code: "PW",
        name: "Palau",
        cname: "帕劳",
        twName: "帕勞",
        codeAlpha3: "PLW",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/palau.png"),
        phoneAreaCode: "680",
        mcc: "552"
    },
    PRY: {
        code: "PY",
        name: "Paraguay",
        cname: "巴拉圭",
        twName: "巴拉圭",
        codeAlpha3: "PRY",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/paraguay.png"),
        phoneAreaCode: "595",
        mcc: "744"
    },
    QAT: {
        code: "QA",
        name: "Qatar",
        cname: "卡塔尔",
        twName: "卡塔爾",
        codeAlpha3: "QAT",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/qatar.png"),
        phoneAreaCode: "974",
        mcc: "427"
    },
    REU: {
        code: "RE",
        name: "Reunion",
        cname: "留尼汪",
        twName: "留尼汪",
        codeAlpha3: "REU",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/reunion.png"),
        phoneAreaCode: "262",
        mcc: "647"
    },
    ROU: {
        code: "RO",
        name: "Romania",
        cname: "罗马尼亚",
        twName: "羅馬尼亞",
        codeAlpha3: "ROU",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/romania.png"),
        phoneAreaCode: "40",
        mcc: "226"
    },
    SRB: {
        code: "RS",
        name: "Serbia",
        cname: "塞尔维亚",
        twName: "塞爾維亞",
        codeAlpha3: "SRB",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/serbia.png"),
        phoneAreaCode: "381",
        mcc: "220"
    },
    RUS: {
        code: "RU",
        name: "Russia",
        cname: "俄罗斯",
        twName: "俄羅斯",
        codeAlpha3: "RUS",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/russian_federation.png"),
        phoneAreaCode: "7",
        mcc: "250"
    },
    RWA: {
        code: "RW",
        name: "Rwanda",
        cname: "卢旺达",
        twName: "盧旺達",
        codeAlpha3: "RWA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/rwanda.png"),
        phoneAreaCode: "250",
        mcc: "635"
    },
    SAU: {
        code: "SA",
        name: "Saudi Arabia",
        cname: "沙特阿拉伯",
        twName: "沙特阿拉伯",
        codeAlpha3: "SAU",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/saudi_arabia.png"),
        phoneAreaCode: "966",
        mcc: "420"
    },
    SLB: {
        code: "SB",
        name: "Solomon Islands",
        cname: "所罗门群岛",
        twName: "所羅門群島",
        codeAlpha3: "SLB",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/solomon_islands.png"),
        phoneAreaCode: "677",
        mcc: "540"
    },
    SYC: {
        code: "SC",
        name: "Seychelles",
        cname: "塞舌尔",
        twName: "塞舌爾",
        codeAlpha3: "SYC",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/seychelles.png"),
        phoneAreaCode: "248",
        mcc: "633"
    },
    SDN: {
        code: "SD",
        name: "Sudan",
        cname: "苏丹",
        twName: "蘇丹",
        codeAlpha3: "SDN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/sudan.png"),
        phoneAreaCode: "249",
        mcc: "634"
    },
    SWE: {
        code: "SE",
        name: "Sweden",
        cname: "瑞典",
        twName: "瑞典",
        codeAlpha3: "SWE",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/sweden.png"),
        phoneAreaCode: "46",
        mcc: "240"
    },
    SGP: {
        code: "SG",
        name: "Singapore",
        cname: "新加坡",
        twName: "新加坡",
        codeAlpha3: "SGP",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/singapore.png"),
        phoneAreaCode: "65",
        mcc: "525"
    },
    SHN: {
        code: "SH",
        name: "Saint Helena",
        cname: "圣赫勒拿、阿森松和特里斯坦-达库尼亚",
        twName: "聖赫勒拿、阿森松和特裏斯坦-達庫尼亞",
        codeAlpha3: "SHN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/saint_helena.png"),
        phoneAreaCode: "290",
        mcc: ""
    },
    SVN: {
        code: "SI",
        name: "Slovenia",
        cname: "斯洛文尼亚",
        twName: "斯洛文尼亞",
        codeAlpha3: "SVN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/slovenia.png"),
        phoneAreaCode: "386",
        mcc: "293"
    },
    SVK: {
        code: "SK",
        name: "Slovakia",
        cname: "斯洛伐克",
        twName: "斯洛伐克",
        codeAlpha3: "SVK",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/slovakia.png"),
        phoneAreaCode: "421",
        mcc: "231"
    },
    SLE: {
        code: "SL",
        name: "Sierra Leone",
        cname: "塞拉利昂",
        twName: "塞拉利昂",
        codeAlpha3: "SLE",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/sierra_leone.png"),
        phoneAreaCode: "232",
        mcc: "619"
    },
    SMR: {
        code: "SM",
        name: "San Marino",
        cname: "圣马力诺",
        twName: "聖馬力諾",
        codeAlpha3: "SMR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/san_marino.png"),
        phoneAreaCode: "378",
        mcc: "292"
    },
    SEN: {
        code: "SN",
        name: "Senegal",
        cname: "塞内加尔",
        twName: "塞內加爾",
        codeAlpha3: "SEN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/senegal.png"),
        phoneAreaCode: "221",
        mcc: "608"
    },
    SOM: {
        code: "SO",
        name: "Somalia",
        cname: "索马里",
        twName: "索馬裏",
        codeAlpha3: "SOM",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/somalia.png"),
        phoneAreaCode: "252",
        mcc: "637"
    },
    SUR: {
        code: "SR",
        name: "Suriname",
        cname: "苏里南",
        twName: "蘇裏南",
        codeAlpha3: "SUR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/suriname.png"),
        phoneAreaCode: "597",
        mcc: "746"
    },
    SSD: {
        code: "SS",
        name: "South Sudan",
        cname: "南苏丹",
        twName: "南蘇丹",
        codeAlpha3: "SSD",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/south_sudan.png"),
        phoneAreaCode: "211",
        mcc: "659"
    },
    STP: {
        code: "ST",
        name: "Sao Tome and Principe",
        cname: "圣多美和普林西比",
        twName: "聖多美和普林西比",
        codeAlpha3: "STP",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/sao_tome_and_principe.png"),
        phoneAreaCode: "239",
        mcc: "626"
    },
    SLV: {
        code: "SV",
        name: "El Salvador",
        cname: "萨尔瓦多",
        twName: "薩爾瓦多",
        codeAlpha3: "SLV",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/el_salvador.png"),
        phoneAreaCode: "503",
        mcc: "706"
    },
    SXM: {
        code: "SX",
        name: "Sint Maarten (Dutch part)",
        cname: "荷属圣马丁",
        twName: "荷屬聖馬丁",
        codeAlpha3: "SXM",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/sint_maarten_(dutch_part).png"),
        phoneAreaCode: "1721",
        mcc: ""
    },
    SYR: {
        code: "SY",
        name: "Syrian Arab Republic",
        cname: "叙利亚",
        twName: "敘利亞",
        codeAlpha3: "SYR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/syrian_arab_republic.png"),
        phoneAreaCode: "963",
        mcc: "417"
    },
    SWZ: {
        code: "SZ",
        name: "Eswatini",
        cname: "斯威士兰",
        twName: "斯威士蘭",
        codeAlpha3: "SWZ",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/eswatini.png"),
        phoneAreaCode: "268",
        mcc: "653"
    },
    TCA: {
        code: "TC",
        name: "Turks and Caicos Islands",
        cname: "特克斯和凯科斯群岛",
        twName: "特克斯和凱科斯群島",
        codeAlpha3: "TCA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/the_turks_and_caicos_islands.png"),
        phoneAreaCode: "1649",
        mcc: "376"
    },
    TCD: {
        code: "TD",
        name: "Chad",
        cname: "乍得",
        twName: "乍得",
        codeAlpha3: "TCD",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/chad.png"),
        phoneAreaCode: "235",
        mcc: "622"
    },
    TGO: {
        code: "TG",
        name: "Togo",
        cname: "多哥",
        twName: "多哥",
        codeAlpha3: "TGO",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/togo.png"),
        phoneAreaCode: "228",
        mcc: "615"
    },
    THA: {
        code: "TH",
        name: "Thailand",
        cname: "泰国",
        twName: "泰國",
        codeAlpha3: "THA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/thailand.png"),
        phoneAreaCode: "66",
        mcc: "520"
    },
    TJK: {
        code: "TJ",
        name: "Tajikistan",
        cname: "塔吉克斯坦",
        twName: "塔吉克斯坦",
        codeAlpha3: "TJK",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/tajikistan.png"),
        phoneAreaCode: "992",
        mcc: "436"
    },
    TKL: {
        code: "TK",
        name: "Tokelau",
        cname: "托克劳",
        twName: "托克勞",
        codeAlpha3: "TKL",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/tokelau.png"),
        phoneAreaCode: "690",
        mcc: ""
    },
    TLS: {
        code: "TL",
        name: "Timor-Leste",
        cname: "东帝汶",
        twName: "東帝汶",
        codeAlpha3: "TLS",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/timor-leste.png"),
        phoneAreaCode: "",
        mcc: "514"
    },
    TKM: {
        code: "TM",
        name: "Turkmenistan",
        cname: "土库曼斯坦",
        twName: "土庫曼斯坦",
        codeAlpha3: "TKM",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/turkmenistan.png"),
        phoneAreaCode: "993",
        mcc: "438"
    },
    TUN: {
        code: "TN",
        name: "Tunisia",
        cname: "突尼斯",
        twName: "突尼斯",
        codeAlpha3: "TUN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/tunisia.png"),
        phoneAreaCode: "216",
        mcc: "605"
    },
    TON: {
        code: "TO",
        name: "Tonga",
        cname: "汤加",
        twName: "湯加",
        codeAlpha3: "TON",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/tonga.png"),
        phoneAreaCode: "676",
        mcc: "539"
    },
    TUR: {
        code: "TR",
        name: "Turkey",
        cname: "土耳其",
        twName: "土耳其",
        codeAlpha3: "TUR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/turkey.png"),
        phoneAreaCode: "90",
        mcc: "286"
    },
    TTO: {
        code: "TT",
        name: "Trinidad and Tobago",
        cname: "特立尼达和多巴哥",
        twName: "特立尼達和多巴哥",
        codeAlpha3: "TTO",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/trinidad_and_tobago.png"),
        phoneAreaCode: "1868",
        mcc: "374"
    },
    TUV: {
        code: "TV",
        name: "Tuvalu",
        cname: "图瓦卢",
        twName: "圖瓦盧",
        codeAlpha3: "TUV",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/tuvalu.png"),
        phoneAreaCode: "688",
        mcc: ""
    },
    TWN: {
        code: "TW",
        name: "Taiwan",
        cname: "中国台湾",
        twName: "臺灣",
        codeAlpha3: "TWN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/taiwan_province_of_china.png"),
        phoneAreaCode: "886",
        mcc: "466"
    },
    TZA: {
        code: "TZ",
        name: "Tanzania, United Republic of",
        cname: "坦桑尼亚",
        twName: "坦桑尼亞",
        codeAlpha3: "TZA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/tanzania_united_republic_of.png"),
        phoneAreaCode: "255",
        mcc: "640"
    },
    UKR: {
        code: "UA",
        name: "Ukraine",
        cname: "乌克兰",
        twName: "烏克蘭",
        codeAlpha3: "UKR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/ukraine.png"),
        phoneAreaCode: "380",
        mcc: "255"
    },
    UGA: {
        code: "UG",
        name: "Uganda",
        cname: "乌干达",
        twName: "烏幹達",
        codeAlpha3: "UGA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/uganda.png"),
        phoneAreaCode: "256",
        mcc: "541"
    },
    USA: {
        code: "US",
        name: "United States of America (the)",
        cname: "美国",
        twName: "美國",
        codeAlpha3: "USA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/usa.png"),
        phoneAreaCode: "1",
        mcc: "310|311|312|313|314|315|316"
    },
    URY: {
        code: "UY",
        name: "Uruguay",
        cname: "乌拉圭",
        twName: "烏拉圭",
        codeAlpha3: "URY",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/uruguay.png"),
        phoneAreaCode: "598",
        mcc: "748"
    },
    UZB: {
        code: "UZ",
        name: "Uzbekistan",
        cname: "乌兹别克斯坦",
        twName: "烏茲別克斯坦",
        codeAlpha3: "UZB",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/uzbekistan.png"),
        phoneAreaCode: "998",
        mcc: "434"
    },
    VAT: {
        code: "VA",
        name: "Holy See (Vatican City State)",
        cname: "梵蒂冈",
        twName: "梵蒂岡",
        codeAlpha3: "VAT",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/holy_see_(vatican_city_state).png"),
        phoneAreaCode: "379",
        mcc: "225"
    },
    VCT: {
        code: "VC",
        name: "Saint Vincent and the Grenadines",
        cname: "圣文森特和格林纳丁斯",
        twName: "聖文森特和格林納丁斯",
        codeAlpha3: "VCT",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/saint_vincent_and_the_grenadines.png"),
        phoneAreaCode: "1784",
        mcc: "360"
    },
    VEN: {
        code: "VE",
        name: "Venezuela",
        cname: "委内瑞拉",
        twName: "委內瑞拉",
        codeAlpha3: "VEN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/venezuela_bolivarian_republic_of.png"),
        phoneAreaCode: "58",
        mcc: "734"
    },
    VGB: {
        code: "VG",
        name: "Virgin Islands, British",
        cname: "英属维尔京群岛",
        twName: "英屬維爾京群島",
        codeAlpha3: "VGB",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/virgin_islands_british.png"),
        phoneAreaCode: "1284",
        mcc: "348"
    },
    VIR: {
        code: "VI",
        name: "Virgin Islands, U.S.",
        cname: "美属维尔京群岛",
        twName: "美屬維爾京群島",
        codeAlpha3: "VIR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/virgin_islands_u.s.png"),
        phoneAreaCode: "",
        mcc: "332"
    },
    VNM: {
        code: "VN",
        name: "Vietnam",
        cname: "越南",
        twName: "越南",
        codeAlpha3: "VNM",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/vietnam.png"),
        phoneAreaCode: "84",
        mcc: "452"
    },
    VUT: {
        code: "VU",
        name: "Vanuatu",
        cname: "瓦努阿图",
        twName: "瓦努阿圖",
        codeAlpha3: "VUT",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/vanuatu.png"),
        phoneAreaCode: "678",
        mcc: "541"
    },
    WLF: {
        code: "WF",
        name: "Wallis and Futuna",
        cname: "瓦利斯和富图纳",
        twName: "瓦利斯和富圖納",
        codeAlpha3: "WLF",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/wallis_and_futuna.png"),
        phoneAreaCode: "681",
        mcc: "543"
    },
    WSM: {
        code: "WS",
        name: "Samoa",
        cname: "萨摩亚",
        twName: "薩摩亞",
        codeAlpha3: "WSM",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/samoa.png"),
        phoneAreaCode: "685",
        mcc: "549"
    },
    YEM: {
        code: "YE",
        name: "Yemen",
        cname: "也门",
        twName: "也門",
        codeAlpha3: "YEM",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/yemen.png"),
        phoneAreaCode: "967",
        mcc: "421"
    },
    MYT: {
        code: "YT",
        name: "Mayotte",
        cname: "马约特",
        twName: "馬約特",
        codeAlpha3: "MYT",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/mayotte.png"),
        phoneAreaCode: "262",
        mcc: ""
    },
    ZAF: {
        code: "ZA",
        name: "South Africa",
        cname: "南非",
        twName: "南非",
        codeAlpha3: "ZAF",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/south_africa.png"),
        phoneAreaCode: "27",
        mcc: "655"
    },
    ZMB: {
        code: "ZM",
        name: "Zambia",
        cname: "赞比亚",
        twName: "贊比亞",
        codeAlpha3: "ZMB",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/zambia.png"),
        phoneAreaCode: "260",
        mcc: "645"
    },
    ZWE: {
        code: "ZW",
        name: "Zimbabwe",
        cname: "津巴布韦",
        twName: "津巴布韋",
        codeAlpha3: "ZWE",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/zimbabwe.png"),
        phoneAreaCode: "263",
        mcc: "648"
    },
    ATA: {
        code: "AQ",
        name: "Antarctica",
        cname: "南极洲",
        twName: "南極洲",
        codeAlpha3: "ATA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/dominican_republic.png"),
        phoneAreaCode: "672",
        mcc: ""
    },
    ALA: {
        code: "AX",
        name: "Aland islands",
        cname: "奥兰群岛",
        twName: "奧蘭",
        codeAlpha3: "ALA",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/dominican_republic.png"),
        phoneAreaCode: "35818",
        mcc: ""
    },
    CCK: {
        code: "CC",
        name: "Cocos (Keeling) Islands",
        cname: "科科斯群岛",
        twName: "科科斯（基林）群島",
        codeAlpha3: "CCK",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/dominican_republic.png"),
        phoneAreaCode: "61",
        mcc: ""
    },
    CXR: {
        code: "CX",
        name: "Christmas Island",
        cname: "圣诞岛",
        twName: "聖誕島",
        codeAlpha3: "CXR",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/dominican_republic.png"),
        phoneAreaCode: "61",
        mcc: ""
    },
    GGY: {
        code: "GG",
        name: "Guernsey",
        cname: "根西岛",
        twName: "根西",
        codeAlpha3: "GGY",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/dominican_republic.png"),
        phoneAreaCode: "44",
        mcc: ""
    },
    SGS: {
        code: "GS",
        name: "South Georgia and the South Sandwich Islands",
        cname: "南乔治亚岛和南桑威奇群岛",
        twName: "南喬治亞與南桑威奇群島",
        codeAlpha3: "SGS",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/dominican_republic.png"),
        phoneAreaCode: "500",
        mcc: ""
    },
    IOT: {
        code: "IO",
        name: "British Indian Ocean Territory",
        cname: "英属印度洋领地",
        twName: "英屬印度洋領地",
        codeAlpha3: "IOT",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/dominican_republic.png"),
        phoneAreaCode: "246",
        mcc: ""
    },
    JEY: {
        code: "JE",
        name: "Jersey",
        cname: "泽西岛",
        twName: "澤西島",
        codeAlpha3: "JEY",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/dominican_republic.png"),
        phoneAreaCode: "44",
        mcc: ""
    },
    MAF: {
        code: "MF",
        name: "Saint-Martin",
        cname: "法属圣马丁",
        twName: "法屬聖馬丁",
        codeAlpha3: "MAF",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/dominican_republic.png"),
        phoneAreaCode: "590",
        mcc: ""
    },
    PCN: {
        code: "PN",
        name: "Pitcairn Islands",
        cname: "皮特凯恩群岛",
        twName: "皮特肯群島",
        codeAlpha3: "PCN",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/dominican_republic.png"),
        phoneAreaCode: "64",
        mcc: ""
    },
    SJM: {
        code: "SJ",
        name: "Svalbard og Jan Mayen",
        cname: "斯瓦尔巴群岛和扬马延岛",
        twName: "斯瓦巴和揚馬延",
        codeAlpha3: "SJM",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/dominican_republic.png"),
        phoneAreaCode: "47",
        mcc: ""
    },
    XKX: {
        code: "XK",
        name: "Kosovo",
        cname: "科索沃",
        twName: "科索沃",
        codeAlpha3: "XKX",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/dominican_republic.png"),
        phoneAreaCode: "383",
        mcc: ""
    },
    PRK: {
        code: "KP",
        name: "North Korea",
        cname: "朝鲜",
        twName: "北朝鮮",
        codeAlpha3: "PRK",
        //image: require("../../../src/TradeUtils/KYCData/countryV2/united_arab_emirates_uae.png"),
        phoneAreaCode: "850",
        mcc: "467",
    },
};
